<template>
    <div>
     <Header :title="title"/>
     
  
      <div class="content_podat">
        <div v-for="c in arr" :key="c.id" class="block_radio">
          <input
            class="custom-radio"
            name="color"
            v-model="kateg"
            type="radio"
            :id="c.id"
            :value="c.id"
            @change="select"
          />
          <label :for="c.id">
            <table>
              <tr>
                  <td>
                  <div :class="c.id" v-html="c.svg"> 
                  </div>
                  </td>
                  <td width="100%"><span>{{c.text}}</span></td>
              </tr>
            </table>  
          </label>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Header from '../components/headerpodat'
  export default {
     components:{
     Header
     },
    
     data() {
      return {
        title:"Выберите категория",
        kateg: "",
        txtkateg: "",
         arr: [
          { id: "avto",
           text: "Легковые автомобили",
           svg:"<svg width='42' height='42' viewBox='0 0 256 256'> <path fill='currentColor' d='M240 112h-10.8l-27.8-62.5a15.9 15.9 0 0 0-14.6-9.5H69.2a15.9 15.9 0 0 0-14.6 9.5L26.8 112H16a8 8 0 0 0 0 16h8v80a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-16h96v16a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-80h8a8 8 0 0 0 0-16ZM80 160H64a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16Zm112 0h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16Z'/></svg>"
          },
          { id: "gruzspes", 
            text: "Грузовики и спецтехника",
            svg:"<svg width='42' height='42' viewBox='0 0 24 24'> <path fill='currentColor' d='M21 6.021c.003-.146-.007-1.465-1.3-2.735C18.427 2.036 17.143 2 17 2H6.996c-.239 0-1.493.063-2.708 1.302C3.036 4.578 3 5.859 3 6v3H2v3h1v6c0 .734.406 1.373 1 1.721V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 21 18v-6h1V9h-1V6.021zM9 4h6v2H9V4zM6.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 18zm4.5-5H5V8h6v5zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 18zm1.5-5h-6V8h6v5z'/></svg>"
           },
        ],
      };
    },
    methods: {
      select() {
          const values = Object.values(this.arr);
          for (let i = 0; i < values.length; i += 1) {
            if (values[i].id === this.kateg) this.txtkateg = values[i].text;
          }
            localStorage.setItem("obmen_kateg",this.kateg );
            localStorage.setItem("obmen_kateg_text",this.txtkateg );
            this.dale();
      },
      dale() {
        if(this.kateg=="avto"){
            this.$router.push({name:"markaObmen"});
        }else{
            this.$router.push({name:"razdelObmen"});
        }
       
       
      },
     
    },
    
  
  };
  </script>
  <style scoped>
  .block_radio {
    margin-bottom: 1.4em;
  }
  .divgorod {
    width: 100%;
    color: #777777;
  }
  .contentgorod {
    font-size: 20px;
    border-bottom: 1px solid #000000;
    padding: 5px 5px 5px 0px;
  }
  label {
    font-size: 18px;
    width: 100%;
  }
  .content_podat {
    padding: 90px 5px 65px 10px;
  }
  </style>